let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hXkhg")).then(() => parcelRequire('kh4hZ'));